import {
  ballArr,
  count,
  singleDouble,
  singleDoubleCnname,
  smallBig,
  smallBigCnname,
  dragonTiger,
  fishCnname
} from "../../../../helpers/resPatterns";
import dayjs from "dayjs";

var isStraight = function(str, i) {
  var arr = str.split(",").slice(i, i + 3);
  var re = [];
  arr.sort((a, b) => {
    return a - b;
  });
  arr.sort((a, b) => {
    re.push(a - b);
  });
  var num = re.reduce((a, b) => {
    return a + b;
  }, 0);
  if (num == 2) {
    return "顺子 ";
  } else if (re.includes(1)) {
    return "半顺";
  } else {
    return "杂六";
  }
};
let treeChildren = index => {
  return [
    {
      align: "center",
      title: "单",
      render: (h, { row }) => <span>{row[index] ? row[index].single : 0}</span>
    },
    {
      align: "center",
      title: "双",
      render: (h, { row }) => <span>{row[index] ? row[index].double : 0}</span>
    },
    {
      align: "center",
      title: "大",
      render: (h, { row }) => <span>{row[index] ? row[index].big : 0}</span>
    },
    {
      align: "center",
      title: "小",
      render: (h, { row }) => <span>{row[index] ? row[index].small : 0}</span>
    }
  ];
};

const hpten = () => {
  let list = Vue => {
    let hasBallOpacity = (x, xIndex, data, dataIndex) => {
      let resClass = "";
      if (Vue.selectType === 0) {
        resClass += !~Vue.selectNumArr.indexOf(x) ? " opacity" : "";
      }
      if (Vue.selectType === 1) {
        resClass += (Vue.selectValue != singleDouble(x)) != 0 ? " opacity" : "";
      }
      if (Vue.selectType === 2) {
        resClass += Vue.selectValue == (x < 11 ? 0 : 1) ? " opacity" : "";
      }
      if (Vue.selectType === 3) {
        let lastStr = data[dataIndex - 1] ? data[dataIndex - 1].resultStr : "";
        let nextStr = data[dataIndex + 1] ? data[dataIndex + 1].resultStr : "";
        let lastArr = ballArr(lastStr);
        let nextArr = ballArr(nextStr);

        if (lastArr[xIndex] === x || nextArr[xIndex] === x) {
        } else {
          resClass += " opacity";
        }
      }
      return resClass;
    };
    return Vue.showMobile
      ? Vue.curKey == "kjhm"
        ? [
            {
              title: "时间",
              align: "center",
              render: (h, { row }) => {
                return <span>{dayjs(row.resultDate).format("HH:mm")}</span>;
              }
            },
            {
              title: "期号",
              width: "130",
              align: "center",
              key: "issueId",
              render: (h, { row }) => {
                return (
                  <span>{row.issueId.substring(row.issueId.length - 4)}</span>
                );
              }
            },
            {
              renderHeader: (h, params) => {
                return (
                  <div class="showBallHandle">
                    <span
                      on-click={_ => (Vue.tableShowBallType = 0)}
                      class={Vue.tableShowBallType == 0 && "active"}
                    >
                      号码
                    </span>
                    <span
                      on-click={_ => (Vue.tableShowBallType = 1)}
                      class={Vue.tableShowBallType == 1 && "active"}
                    >
                      大小
                    </span>
                    <span
                      on-click={_ => (Vue.tableShowBallType = 2)}
                      class={Vue.tableShowBallType == 2 && "active"}
                    >
                      单双
                    </span>
                  </div>
                );
              },
              width: 400,
              align: "center",
              render: (h, { row, index }) => {
                let arr = ballArr(row.resultStr);
                let boxClassName = "ball";
                if (Vue.tableShowBallType == 0) {
                  boxClassName += " num";
                  arr = arr.map((x, i) => {
                    let className = "";
                    className += hasBallOpacity(x, i, Vue.dataSource, index);
                    return { value: x, className };
                  });
                }
                if (Vue.tableShowBallType == 1) {
                  boxClassName += " smallBig";
                  arr = arr.map((x, i) => {
                    let className;

                    className = x < 11 ? "small" : "big";

                    className += hasBallOpacity(x, i, Vue.dataSource, index);
                    return { value: "", className };
                  });
                }
                if (Vue.tableShowBallType == 2) {
                  boxClassName += " singleDouble";
                  arr = arr.map((x, i) => {
                    let className;
                    className = singleDouble(x) == 0 ? "single" : "double";
                    className += hasBallOpacity(x, i, Vue.dataSource, index);
                    return { value: "", className };
                  });
                }

                return (
                  <div class={boxClassName}>
                    {arr.map((x, i) => {
                      return (
                        <span
                          class={x.className}
                          key={i}
                          style={{
                            backgroundColor: `${
                              Vue.tableShowBallType == 0
                                ? `${
                                    x.value == 19 || x.value == 20
                                      ? "rgb(228, 76, 63)"
                                      : "#1299df"
                                  }`
                                : "white"
                            }`
                          }}
                        >
                          {x.value && x.value < 10 ? "0" + x.value : x.value}
                        </span>
                      );
                    })}
                  </div>
                );
              }
            }
          ]
        : [
            {
              title: "时间",
              align: "center",
              render: (h, { row }) => {
                return <span>{dayjs(row.resultDate).format("HH:mm")}</span>;
              }
            },
            {
              title: "期数",
              width: "130",
              align: "center",
              key: "issueId",
              render: (h, { row }) => {
                return (
                  <span>{row.issueId.substring(row.issueId.length - 4)}</span>
                );
              }
            },
            {
              title: "总和",
              align: "center",
              render: (h, { row }) => {
                let arr = ballArr(row.resultStr);
                return (
                  <div class="insideTableTd">
                    <p class="count brr">{count(arr)}</p>
                  </div>
                );
              }
            },
            {
              title: "单双",
              align: "center",
              render: (h, { row }) => {
                let arr = ballArr(row.resultStr);
                return (
                  <div class="insideTableTd">
                    <p class="singleDouble brr">
                      {singleDouble(count(arr)) == 0 ? (
                        <span class="blue">单</span>
                      ) : (
                        <span class="red">双</span>
                      )}
                    </p>
                  </div>
                );
              }
            },
            {
              title: "大小",
              align: "center",
              render: (h, { row }) => {
                let arr = ballArr(row.resultStr);
                return (
                  <div class="insideTableTd">
                    <p class="smallBig">
                      {count(arr) == 84 ? (
                        <span class="blue">和</span>
                      ) : smallBig(count(arr), 168) == 0 ? (
                        <span class="blue">小</span>
                      ) : (
                        <span class="red">大</span>
                      )}
                    </p>
                  </div>
                );
              }
            },
            {
              title: "1-4龙虎",
              align: "center",
              render: (h, { row }) => {
                let arr = ballArr(row.resultStr);
                let res = dragonTiger(arr[0], arr[7]);
                let res1 = dragonTiger(arr[1], arr[6]);
                let res2 = dragonTiger(arr[2], arr[5]);
                let res3 = dragonTiger(arr[3], arr[4]);
                return (
                  <div class="insideTableTd">
                    <p class="singleDouble brr">
                      {res == 0 ? (
                        <span class="blue">龙</span>
                      ) : (
                        <span class="red">虎</span>
                      )}
                    </p>
                    <p class="singleDouble brr">
                      {res1 == 0 ? (
                        <span class="blue">龙</span>
                      ) : (
                        <span class="red">虎</span>
                      )}
                    </p>
                    <p class="singleDouble brr">
                      {res2 == 0 ? (
                        <span class="blue">龙</span>
                      ) : (
                        <span class="red">虎</span>
                      )}
                    </p>
                    <p class="singleDouble brr">
                      {res3 == 0 ? (
                        <span class="blue">龙</span>
                      ) : (
                        <span class="red">虎</span>
                      )}
                    </p>
                  </div>
                );
              }
            }
          ]
      : [
          {
            title: "时间",
            align: "center",
            render: (h, { row }) => {
              return (
                <span>
                  {dayjs(row.resultDate).format("YYYY-MM-DD HH:mm:ss")}
                </span>
              );
            }
          },
          {
            title: "期数",
            width: "130",
            align: "center",
            key: "issueId"
          },
          {
            renderHeader: (h, params) => {
              return (
                <div class="showBallHandle">
                  <span
                    on-click={_ => (Vue.tableShowBallType = 0)}
                    class={Vue.tableShowBallType == 0 && "active"}
                  >
                    显示号码
                  </span>
                  <span
                    on-click={_ => (Vue.tableShowBallType = 1)}
                    class={Vue.tableShowBallType == 1 && "active"}
                  >
                    显示大小
                  </span>
                  <span
                    on-click={_ => (Vue.tableShowBallType = 2)}
                    class={Vue.tableShowBallType == 2 && "active"}
                  >
                    显示单双
                  </span>
                </div>
              );
            },
            width: 400,
            align: "center",
            render: (h, { row, index }) => {
              let arr = ballArr(row.resultStr);
              let boxClassName = "ball";
              if (Vue.tableShowBallType == 0) {
                boxClassName += " num";
                arr = arr.map((x, i) => {
                  let className = "";
                  className += hasBallOpacity(x, i, Vue.dataSource, index);
                  return { value: x, className };
                });
              }
              if (Vue.tableShowBallType == 1) {
                boxClassName += " smallBig";
                arr = arr.map((x, i) => {
                  let className;

                  className = x < 11 ? "small" : "big";

                  className += hasBallOpacity(x, i, Vue.dataSource, index);
                  return { value: "", className };
                });
              }
              if (Vue.tableShowBallType == 2) {
                boxClassName += " singleDouble";
                arr = arr.map((x, i) => {
                  let className;
                  className = singleDouble(x) == 0 ? "single" : "double";
                  className += hasBallOpacity(x, i, Vue.dataSource, index);
                  return { value: "", className };
                });
              }

              return (
                <div class={boxClassName}>
                  {arr.map((x, i) => {
                    return (
                      <span
                        class={x.className}
                        key={i}
                        style={{
                          border: `${
                            Vue.tableShowBallType == 0
                              ? `1px solid ${
                                  x.value == 19 || x.value == 20
                                    ? "red"
                                    : "#1299df"
                                }`
                              : "none"
                          }`
                        }}
                      >
                        {x.value && x.value < 10 ? "0" + x.value : x.value}
                      </span>
                    );
                  })}
                </div>
              );
            }
          },
          {
            title: "总和",
            align: "center",
            render: (h, { row }) => {
              let arr = ballArr(row.resultStr);
              return (
                <div class="insideTableTd">
                  <p class="count brr">{count(arr)}</p>
                  <p class="singleDouble brr">
                    {singleDouble(count(arr)) == 0 ? (
                      <span class="blue">单</span>
                    ) : (
                      <span class="red">双</span>
                    )}
                  </p>
                  <p class="smallBig">
                    {count(arr) == 84 ? (
                      <span class="blue">和</span>
                    ) : smallBig(count(arr), 168) == 0 ? (
                      <span class="blue">小</span>
                    ) : (
                      <span class="red">大</span>
                    )}
                  </p>
                </div>
              );
            }
          },
          {
            title: "尾大小",
            align: "center",
            width: 80,
            render: (h, { row }) => {
              let all = ballArr(row.resultStr);
              var last = count(all)
                .toString()
                .slice(-1);
              return (
                <p class="singleDouble brr">
                  {last > 4 ? (
                    <span class="blue">尾大</span>
                  ) : (
                    <span class="red">尾小</span>
                  )}
                </p>
              );
            }
          },
          {
            title: "龙虎",
            align: "center",
            render: (h, { row }) => {
              let arr = ballArr(row.resultStr);
              let res = dragonTiger(arr[0], arr[7]);
              let res1 = dragonTiger(arr[1], arr[6]);
              let res2 = dragonTiger(arr[2], arr[5]);
              let res3 = dragonTiger(arr[3], arr[4]);
              return (
                <div class="insideTableTd">
                  <p class="singleDouble brr">
                    {res == 0 ? (
                      <span class="blue">龙</span>
                    ) : (
                      <span class="red">虎</span>
                    )}
                  </p>
                  <p class="singleDouble brr">
                    {res1 == 0 ? (
                      <span class="blue">龙</span>
                    ) : (
                      <span class="red">虎</span>
                    )}
                  </p>
                  <p class="singleDouble brr">
                    {res2 == 0 ? (
                      <span class="blue">龙</span>
                    ) : (
                      <span class="red">虎</span>
                    )}
                  </p>
                  <p class="singleDouble brr">
                    {res3 == 0 ? (
                      <span class="blue">龙</span>
                    ) : (
                      <span class="red">虎</span>
                    )}
                  </p>
                </div>
              );
            }
          }
        ];
  };

  let doubleStatisColumns1 = [
    {
      title: "号码",
      width: 176,
      align: "center",
      key: "title"
    },
    {
      title: "第一球",
      align: "center",
      children: treeChildren(1)
    },
    {
      title: "第二球",
      align: "center",
      children: treeChildren(2)
    },
    {
      title: "第三球",
      align: "center",
      children: treeChildren(3)
    },
    {
      title: "第四球",
      align: "center",
      children: treeChildren(4)
    },
    {
      title: "第五球",
      align: "center",
      children: treeChildren(5)
    },
    {
      title: "第六球",
      align: "center",
      children: treeChildren(6)
    },
    {
      title: "第七球",
      align: "center",
      children: treeChildren(7)
    },
    {
      title: "第八球",
      align: "center",
      children: treeChildren(8)
    }
  ];
  let doubleStatisColumns2 = [
    {
      title: "球次",
      align: "center",
      key: "title"
    },
    {
      title: "总和",
      align: "center",
      children: treeChildren("count")
    },
    {
      align: "center",
      title: "第一名龙虎",
      children: [
        {
          align: "center",
          title: "龙",
          render: (h, { row }) => <span>{row[0].dragon}</span>
        },
        {
          align: "center",
          title: "虎",
          render: (h, { row }) => <span>{row[0].tiger}</span>
        }
      ]
    },
    {
      title: "第二名龙虎",
      align: "center",
      children: [
        {
          align: "center",
          title: "龙",
          render: (h, { row }) => <span>{row[1].dragon}</span>
        },
        {
          align: "center",
          title: "虎",
          render: (h, { row }) => <span>{row[1].tiger}</span>
        }
      ]
    },
    {
      align: "center",
      title: "第三名龙虎",
      children: [
        {
          align: "center",
          title: "龙",
          render: (h, { row }) => <span>{row[2].dragon}</span>
        },
        {
          align: "center",
          title: "虎",
          render: (h, { row }) => <span>{row[2].tiger}</span>
        }
      ]
    },
    {
      align: "center",
      title: "第四名龙虎",
      children: [
        {
          align: "center",
          title: "龙",
          render: (h, { row }) => <span>{row[3].dragon}</span>
        },
        {
          align: "center",
          title: "虎",
          render: (h, { row }) => <span>{row[3].tiger}</span>
        }
      ]
    }
  ];

  return { list, doubleStatisColumns1, doubleStatisColumns2 };
};

export default hpten;



// WEBPACK FOOTER //
// ./src/pages/Trend/Jishikaijiang/columns/hpten.js